// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--11-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--11-2!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js??ref--11-3!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/zoom/ZoomSliderWrapper.vue?vue&type=style&index=0&id=7c5f5a02&scoped=true&lang=scss&
// module id = 157
// module chunks = 0